import axios, { getErrorMessage } from '../utils/axios';

export function buildQuery(params = {}) {
  const search = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      search.append(key, value);
    }
  });

  const query = search.toString();
  return query ? `?${query}` : '';
}

export async function fetchAdmin(path, params) {
  const response = await axios.get(`${path}${buildQuery(params)}`);
  return response.data;
}

export async function postAdmin(path, payload) {
  const response = await axios.post(path, payload);
  return response.data;
}

export async function putAdmin(path, payload) {
  const response = await axios.put(path, payload);
  return response.data;
}

export async function deleteAdmin(path) {
  const response = await axios.delete(path);
  return response.data;
}

export function safeJsonParse(value, fallback = null) {
  if (!value || typeof value !== 'string') {
    return fallback;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    return fallback;
  }
}

export function toErrorMessage(error) {
  return getErrorMessage(error);
}
